/* MotoEBikes REVVI fulfilment selection. Unpublished theme testing. */
(function(){
  function initialize(){
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function(form){
      if(form.dataset.mebRevviInitialized==='true')return;
      var selector=form.querySelector('[data-revvi-selector]');
      if(!selector)return;
      form.dataset.mebRevviInitialized='true';
      var summary=selector.querySelector('.meb-revvi-fulfilment__summary');
      var price=selector.querySelector('[data-revvi-price]');
      var error=selector.querySelector('[data-revvi-error]');
      selector.addEventListener('change',function(e){
        if(e.target.name!=='meb_revvi_method')return;
        var checked=selector.querySelector('input[name="meb_revvi_method"]:checked');
        price.textContent=checked.dataset.feePence==='0'?'Free':'£'+(Number(checked.dataset.feePence)/100).toFixed(2);
        summary.hidden=false;error.hidden=true;
      });
      form.addEventListener('submit',async function(e){
        e.preventDefault();e.stopImmediatePropagation();
        var checked=selector.querySelector('input[name="meb_revvi_method"]:checked');
        if(!checked){error.textContent='Please choose delivery or collection before adding your REVVI.';error.hidden=false;selector.scrollIntoView({behavior:'smooth',block:'center'});return;}
        var variantInput=form.querySelector('[name="id"]');
        var button=form.querySelector('[type="submit"]');
        if(!variantInput||!variantInput.value||button.disabled)return;
        var qty=Math.max(1,parseInt(form.querySelector('[name="quantity"]')?.value||'1',10));
        var label=checked.closest('label').querySelector('strong').textContent.trim();
        var group='meb-'+Date.now()+'-'+Math.random().toString(36).slice(2,10);
        var items=[{id:Number(variantInput.value),quantity:qty,properties:{'REVVI delivery or collection':label,'_MEB fulfilment group':group}}];
        if(checked.dataset.feeVariant)items.push({id:Number(checked.dataset.feeVariant),quantity:qty,properties:{'_REVVI bike variant':variantInput.value,'_MEB fulfilment group':group,'REVVI delivery or collection':label}});
        button.disabled=true;button.setAttribute('aria-busy','true');
        try{
          var response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
          var data=await response.json();
          if(!response.ok)throw new Error(data.description||data.message||'Could not add the bike. Please try again.');
          window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
        }catch(ex){error.textContent=ex.message||'An error occurred. Please try again.';error.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');}
      },true);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();